var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container" }, [
    _c("div", { staticClass: "top" }, [
      _c("div", { staticClass: "top-content" }, [
        _c("div", { staticClass: "top-left algin-class" }, [
          _vm._v(_vm._s(_vm.language["ipsys.createBy"]))
        ]),
        _c("div", { staticClass: "top-right top-right-algin" }, [
          _vm._v(_vm._s(_vm.model.userRealName) + " ")
        ])
      ]),
      _c("div", { staticClass: "top-content" }, [
        _c("div", { staticClass: "top-left algin-class" }, [
          _vm._v(_vm._s(_vm.language["column.jobNumber"]))
        ]),
        _c("div", { staticClass: "top-right top-right-algin" }, [
          _vm._v(_vm._s(_vm.model.userWorkNo) + " ")
        ])
      ]),
      _c("div", { staticClass: "top-content" }, [
        _c("div", { staticClass: "top-left algin-class" }, [
          _vm._v(_vm._s(_vm.language["portal.front.factory"]))
        ]),
        _c("div", { staticClass: "top-right top-right-algin" }, [
          _vm._v(_vm._s(_vm.model.userFactory) + " ")
        ])
      ]),
      _c("div", { staticClass: "top-content" }, [
        _c("div", { staticClass: "top-left algin-class" }, [
          _vm._v(_vm._s(_vm.language["esg.unit"]))
        ]),
        _c("div", { staticClass: "top-right top-right-algin" }, [
          _vm._v(_vm._s(_vm.model.userDepartName) + " ")
        ])
      ]),
      _c("div", { staticClass: "top-content" }, [
        _c("div", { staticClass: "top-left algin-class" }, [
          _vm._v(_vm._s(_vm.language["hhemp.extension"]))
        ]),
        _c("div", { staticClass: "top-right top-right-algin" }, [
          _vm._v(_vm._s(_vm.model.userTelephone) + " ")
        ])
      ]),
      _c("div", { staticClass: "top-content" }, [
        _c("div", { staticClass: "top-left algin-class" }, [
          _vm._v(_vm._s(_vm.language["column.mailbox"]))
        ]),
        _c("div", { staticClass: "top-right top-right-algin" }, [
          _vm._v(_vm._s(_vm.model.userMail) + " ")
        ])
      ]),
      _c("div", { staticClass: "top-content" }, [
        _c("div", { staticClass: "top-left algin-class" }, [
          _vm._v(_vm._s(_vm.language["hhemp.position"]))
        ]),
        _c("div", { staticClass: "top-right top-right-algin" }, [
          _vm._v(_vm._s(_vm.model.userEmpClass) + " ")
        ])
      ]),
      _c("div", { staticClass: "top-content" }, [
        _c("div", { staticClass: "top-left algin-class" }, [
          _vm._v(_vm._s(_vm.language["ipsys.createTime"]))
        ]),
        _c("div", { staticClass: "top-right top-right-algin" }, [
          _vm._v(_vm._s(_vm.model.createTime) + " ")
        ])
      ]),
      _c("div", { staticClass: "top-content" }, [
        _c("div", { staticClass: "top-left algin-class" }, [
          _vm._v(_vm._s(_vm.language["hhemp.question.type"]))
        ]),
        _c("div", { staticClass: "top-right top-right-algin" }, [
          _vm._v(_vm._s(_vm.feedbackTypeName) + " ")
        ])
      ]),
      _c("div", { staticClass: "top-content" }, [
        _c("div", { staticClass: "top-left algin-class" }, [
          _vm._v(_vm._s(_vm.language["ipsys.titie"]))
        ]),
        _c("div", { staticClass: "top-right top-right-algin" }, [
          _vm._v(_vm._s(_vm.model.title) + " ")
        ])
      ]),
      _c("div", { staticClass: "top-content" }, [
        _c("div", { staticClass: "top-left algin-class" }, [
          _vm._v(_vm._s(_vm.language["announcement.msgContent"]))
        ]),
        _c("div", { staticClass: "top-right top-right-algin" }, [
          _vm._v(_vm._s(_vm.model.content) + " ")
        ])
      ])
    ]),
    _vm.handleType == "processed" && _vm.model.status == "0"
      ? _c(
          "div",
          { staticClass: "buttom" },
          [
            _c("a-textarea", {
              attrs: {
                rows: "8",
                placeholder: _vm.language["hhemp.input.suggestions"]
              },
              model: {
                value: _vm.model.processedOpinions,
                callback: function($$v) {
                  _vm.$set(_vm.model, "processedOpinions", $$v)
                },
                expression: "model.processedOpinions"
              }
            })
          ],
          1
        )
      : _vm._e(),
    _vm.model.status == "1"
      ? _c("div", { staticClass: "processed" }, [
          _c("div", { staticClass: "top-content" }, [
            _c(
              "div",
              { staticClass: "top-left algin-class algin-class-processed" },
              [_vm._v(_vm._s(_vm.language["portal.ui2.processStatus"]))]
            ),
            _c("div", { staticClass: "top-right top-right-algin" }, [
              _vm._v(_vm._s(_vm.language["web.processed"]) + " ")
            ])
          ]),
          _c("div", { staticClass: "top-content" }, [
            _c(
              "div",
              { staticClass: "top-left algin-class algin-class-processed" },
              [_vm._v(_vm._s(_vm.language["sweep_handleDate"]))]
            ),
            _c("div", { staticClass: "top-right top-right-algin " }, [
              _vm._v(_vm._s(_vm.model.processedTime) + " ")
            ])
          ]),
          _c("div", { staticClass: "top-content" }, [
            _c(
              "div",
              { staticClass: "top-left algin-class algin-class-processed" },
              [_vm._v(_vm._s(_vm.language["sweep_handleName"]))]
            ),
            _c("div", { staticClass: "top-right top-right-algin " }, [
              _vm._v(_vm._s(_vm.model.processedName) + " ")
            ])
          ]),
          _c("div", { staticClass: "top-content" }, [
            _c(
              "div",
              { staticClass: "top-left algin-class algin-class-processed" },
              [_vm._v(_vm._s(_vm.language["hhemp.processing.suggestions"]))]
            ),
            _c("div", { staticClass: "top-right top-right-algin " }, [
              _vm._v(_vm._s(_vm.model.processedOpinions) + " ")
            ])
          ])
        ])
      : _vm._e(),
    _vm.model.status == "1" && _vm.model.scoreStatus == "1"
      ? _c("div", { staticClass: "source" }, [
          _c("div", { staticClass: "top-content " }, [
            _c(
              "div",
              {
                staticClass:
                  "top-left algin-class algin-class-processed source-class"
              },
              [_vm._v(_vm._s(_vm.language["hhemp.satisfaction"]))]
            ),
            _c(
              "div",
              { staticClass: "top-right top-right-algin" },
              [
                _c("a-rate", {
                  attrs: { "default-value": _vm.model.score, disabled: "" }
                }),
                _vm._v("(" + _vm._s(_vm.language["hhemp.rated"]) + ") ")
              ],
              1
            )
          ]),
          _c("div", { staticClass: "top-content" }, [
            _c(
              "div",
              {
                staticClass:
                  "top-left algin-class algin-class-processed source-class"
              },
              [_vm._v(_vm._s(_vm.language["hhemp.scoring.opinions"]))]
            ),
            _c("div", { staticClass: "top-right top-right-algin " }, [
              _vm._v(_vm._s(_vm.model.scoreOpinions) + " ")
            ])
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }